import React, { useEffect, useState } from "react";
import moment from "moment";
import Accordion from "react-bootstrap/Accordion";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { 
    get_payment_invoices, 
    get_beneficiary_reimbursement,
    getAllocateBudgetList,
    get_single_beneficiary_reimbursement
} from "../../helper/Api";
import ApprovalOverlayListView from "./ListView/ApprovalOverlayListView";

const ApprovalOverlay = ({
    fy_list,
    handleYearDropdown,
    dividerNumber,
    addElipsis,
    formatNumber,
    approvalsOverlay,
    storedGlobalDateId,
    setApprovalsOverlay,
    invoices,
    filterPayload
}) => {
    const {authData}=useSelector((state)=>state.authData);
    const navigate = useNavigate();
     const [listview, setListview] = useState(true);
    const [activeKeys, setActiveKeys] = useState([]);
     const [overlayDropDown, setOverlayDropDown] = useState(false);
       const [subheadAccording, setSubheadAccording] = useState({});
       const [singleBeneficiarys, setSingleBeneficiarys] = useState([]);
       const [vendorPaymentData, setVendorPaymentData] = useState([]);
       const [dbtData, setDbtData] = useState([]);
       const [subheadAccordingdbt, setSubheadAccordingdbt] = useState({});
       const [childAllocationData, setChildAllocationData] = useState([]);
        const [expandedIndex, setExpandedIndex] = useState(null);
        const [childAllocationEyeData, setChildAllocationEyeData] = useState([]);
        const [ dbtPaymentData, setDbtPaymentData] = useState([]);

    const date = [
        {
        id: "1",
        code: "2",
        department: "Scheme",
        total_provisional_budget: "200000",
        total_budget: "200000",
        prevYearBalance: "200000",
        utilised_budget: "200000",
        },
    ];

     
      const fetchChildEyeData = async (id) => {
        try {
          const { data } = await getAllocateBudgetList({ id });
          setChildAllocationEyeData(data?.result[0]?.budget_details);
          console.log(data?.result[0]?.budget_details);
        } catch (err) {
          console.log(err.name);
        }
      };
      // Get the count
    const vendorApprovalTotal = invoices.length;
    const vendorPaymentTotal = vendorPaymentData.length;

    const vendorApprovalReduce = invoices?.map((val, ind) => val.sanction_amount);
    const vendorPaymentReduce = vendorPaymentData?.map(
        (val, ind) => val.payable_amount
    );
  

    const totalVendorApprovalReduce = vendorApprovalReduce?.reduce(
        (sum, num) => sum + Number(num),
        0
      );
      const totalVendorPaymentReduce = vendorPaymentReduce?.reduce(
        (sum, num) => sum + Number(num),
        0
      );
      const totalSanctionAmountDbt = dbtData?.reduce(
        (sum, val) => sum + Number(val?.reimbursement_order_value || 0),
        0
      );
      const totalSanctionPaymentAmountDbt = dbtPaymentData?.reduce(
        (sum, val) => sum + Number(val?.reimbursement_order_value || 0),
        0
      );


        const lengthchildAllocationData = childAllocationData.length;
      
        const provisonReduct = childAllocationData?.map(
          (val, ind) => val.total_scheme_provisional_allocation
        );
        const provisonReleased = childAllocationData?.map(
          (val, ind) => val.total_scheme_released_allocation
        );
      
        const totalprovisonReduct = provisonReduct?.reduce(
          (sum, num) => sum + Number(num),
          0
        );
        const totalprovisonReleased = provisonReleased?.reduce(
          (sum, num) => sum + Number(num),
          0
        );

    const toggleAccordion = (key) => {
        setActiveKeys(
            (prevKeys) =>
            prevKeys.includes(key)
                ? prevKeys.filter((k) => k !== key) // Remove key if it's already open
                : [...prevKeys, key] // Add key if it's closed
        );
        };


    useEffect(() => {
        if (dbtData.length > 0) {
          const initialState = dbtData?.reduce((acc, _, index) => {
            acc[index] = true; // Set `true` to collapse all rows initially
            return acc;
          }, {});
          setSubheadAccordingdbt(initialState);
        }
      }, [dbtData]);

    const toggleSubheadAccording = (index) => {
    setSubheadAccordingdbt((prev) => ({
        ...prev,
        [index]: !prev[index], // Toggle only for the specific row
    }));
    };


    const getSingleBeneficiaryReimbursements = async (id) => {
        try {
          const { data } = await get_single_beneficiary_reimbursement(id);
          setSingleBeneficiarys(data.result.beneficiaries);
        } catch (err) {
          console.log(err.name);
        }
      };

    const fetchBudgets = async (payload) => {
        try {
          const { data } = await getAllocateBudgetList(payload);
          setChildAllocationData(data.result);
        } catch (error) {
          console.log(error);
        }
      };

    const fetchVendorPaymentInvoices = async () => {
    try {
        const invoices_response = await get_payment_invoices({
            user_type: authData?.user?.user_type?.toUpperCase() || "L1",
            department_id: filterPayload.department_id || authData?.user?.department_id,
        });
        if (invoices_response.data.status) {
        setVendorPaymentData(invoices_response.data.list);
        } else {
        // dispatch(GET_P_INVOICES_FAIL(invoices_response.data.message))
        }
    } catch (error) {
        // dispatch(GET_P_INVOICES_FAIL('something went wrong'))
    }
    };

    const fetchChallans = async (listType) => {
        try {
          const resp = await get_beneficiary_reimbursement({
            department_id: filterPayload.department_id || authData.user.department_id,
            listType,
            is_all: false
          });
          if (resp.data.status) {
            if(listType === "approval") {
                setDbtData(resp.data.result);
            }
            if(listType === "payment") {
                setDbtPaymentData(resp.data.result);
            }
          }
        } catch (error) {
        //   setDbtData([]);
        }
      };

    useEffect(() => {
        fetchVendorPaymentInvoices();
        fetchChallans("approval");
        fetchChallans("payment");
        fetchBudgets({
            pending: true,
            department_id: filterPayload.department_id || authData.user.department_id,
          });
    },[filterPayload]);

    return (
        <>
            <div
                    className={`overlayContent overflow-x-hidden overflow-y-auto ${
                      approvalsOverlay ? "left-100" : null
                    } `}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="bg-secondary-100 position-relative text-white d-flex justify-content-between align-items-center p-3 position-sticky top-0 z-3">
                      <div className="fw-600 fs-16px d-flex align-items-center gap-1 ">
                        <i
                          className="icon-close_circle_fill fs-5  cursor-pointer"
                          onClick={() => setApprovalsOverlay(true)}
                        ></i>
                        For Approvals & Payment
                      </div>
            
                      <div className="d-flex gap-2 align-items-center ">
                        <span>
                          As on date{" "}
                          { moment().format('Do MMMM YYYY') }
                        </span>
                        <i
                          className="icon-arrow_drop_down_circle fs-18px cursor-pointer"
                          onClick={() => setOverlayDropDown((prev) => !prev)}
                        ></i>
            
                        <div
                          className={`position-absolute bg-prime-100 w-100 p-3 ${
                            !overlayDropDown ? "d-none" : "d-inline-block"
                          }`}
                          style={{ top: "100%", zIndex: "10" }}
                        >
                          <div className="d-flex flex-column gap-4">
                            <span className="d-flex align-items-center gap-2">
                              {" "}
                              <i className="icon-featured_play_list"></i> Export Excel
                            </span>
                            <span className="d-flex align-items-center gap-2">
                              {" "}
                              <i className="icon-picture_as_pdf"></i> Export PDF
                            </span>
                            <span
                              className="d-flex align-items-center gap-2 cursor-pointer"
                              onClick={() => setListview(false)}
                            >
                              {" "}
                              <i className="icon-view_list"></i> List View
                            </span>
                            <span
                              className="d-flex align-items-center gap-2 cursor-pointer"
                              onClick={() => setListview(true)}
                            >
                              {" "}
                              <i className="icon-grid_on"></i> Grid View
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
            
                    <div className="px-4 py-3 d-flex flex-column gap-2">
                      {/* ===================================table view ====================================== */}
            
                      <ApprovalOverlayListView 
                      listview={listview} 
                      addElipsis={addElipsis} 
                      invoices={invoices}
                      formatNumber={formatNumber}
                      dividerNumber={dividerNumber}
                        vendorPaymentData={vendorPaymentData}
                        dbtData={dbtData}
                        dbtPaymentData={dbtPaymentData}
                        childAllocationData={childAllocationData}
                      />
            






                      {/* =================================== card view=========================== */}
                      {listview && (
                        <div className="d-flex flex-column gap-2">
                          {/* =============================vendor card==================== */}
            
                          <div
                            className="bg-white border-Prime-100"
                            style={{ borderRadius: "8px" }}
                          >
                            <div
                              className="bg-prime-20 d-flex justify-content-between align-items-center p-2 transition overflow-hidden "
                              style={{ borderRadius: "8px 8px 0 0" }}
                            >
                              {/* ======================card header================== */}
                              <span
                                className="fs-14px white-space-nowrap overflow-x-hidden"
                                style={{ width: "95%", fontStyle: "italic" }}
                              >
                                {/* =======================card header====================== */}
                                <span
                                  className="fs-14px white-space-nowrap overflow-x-hidden "
                                  style={{ width: "95%", fontStyle: "italic" }}
                                >
                                  <span className="fw-500 text-secondary-100">Vendor</span>
                                </span>
                              </span>
            
                              <span>
                                <i className="icon-remove_red_eye cursor-pointer"></i>
                              </span>
                            </div>
            
                            {/* ================== card body ========================= */}
            
                            <div className="row py-2 px-3">
                              <div className="row">
                                <div className="col-4 d-flex flex-column">
                                  <span className="text-black-60 fs-12px">Approval</span>
                                  <span className="fw-500 fs-14px">
                                    {totalVendorApprovalReduce == 0
                                      ? "-"
                                      : formatNumber(
                                          totalVendorApprovalReduce / dividerNumber,
                                          "indian"
                                        )}
                                  </span>
                                </div>
                                <div className="col-4 d-flex flex-column">
                                  <span className="text-black-60 fs-12px d-flex justify-content-between align-items-center">
                                    Payment
                                    <span>
                                      <i className="icon-info cursor-pointer"></i>
                                    </span>
                                  </span>
                                  <span className="fw-500 fs-14px">
                                    {totalVendorPaymentReduce == 0
                                      ? "-"
                                      : formatNumber(
                                          totalVendorPaymentReduce / dividerNumber,
                                          "indian"
                                        )}
                                  </span>
                                </div>
                                <div className="col-4 d-flex flex-column bg-success-20 py-2">
                                  <span className="text-black-60 fs-12px d-flex justify-content-between align-items-center">
                                    Total
                                    <span>
                                      <i className="icon-info cursor-pointer"></i>
                                    </span>
                                  </span>
                                  <span className="fw-500 fs-14px">
                                    {totalVendorApprovalReduce + totalVendorPaymentReduce ==
                                    0
                                      ? "-"
                                      : formatNumber(
                                          (totalVendorApprovalReduce +
                                            totalVendorPaymentReduce) /
                                            dividerNumber,
                                          "indian"
                                        )}
                                  </span>
                                </div>
                              </div>
                            </div>
            
                            <div className="d-flex">
                              <div className=" ps-3 py-2 d-flex gap-8px invoice-hover">
                                <span
                                  className="d-flex align-items-center border rounded-2 gap-8px"
                                  style={{ padding: "2px 8px" }}
                                >
                                  Invoice for Approval - {vendorApprovalTotal}
                                  <i
                                    className="icon-open_in_new cursor-pointer"
                                    onClick={() =>
                                      navigate("/fund-invoice-list?pending=false")
                                    }
                                  ></i>
                                </span>
                              </div>
                              <div className="px-3 py-2 d-flex gap-8px invoice-hover">
                                <span
                                  className="d-flex align-items-center border rounded-2 gap-8px"
                                  style={{ padding: "2px 8px" }}
                                >
                                  Invoice for payment - {vendorPaymentTotal}
                                  <i
                                    className="icon-open_in_new cursor-pointer"
                                    onClick={() =>
                                      navigate("/fund-invoice-list?pending=true")
                                    }
                                  ></i>
                                </span>
                              </div>
                            </div>
            
                            <div className="px-3 pb-2 d-flex flex-column gap-1">
                              <Accordion activeKey={activeKeys} style={{ border: "0" }}>
                                <Accordion.Item
                                  eventKey="0"
                                  style={{ borderRadius: "0", border: "0" }}
                                >
                                  <Accordion.Header
                                    onClick={() => toggleAccordion("0")}
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      position: "relative",
                                      borderRadius: "0",
                                    }}
                                  >
                                    <div className="w-100 d-flex justify-content-between">
                                      <span>Pending for Approval</span>
                                      <span
                                        className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                        style={{ height: "13.33px", width: "13.33px" }}
                                      >
                                        {activeKeys.includes("0") ? "-" : "+"}
                                      </span>
                                    </div>
                                  </Accordion.Header>
            
                                  <Accordion.Body>
                                    <div
                                      className="ps-3 overflow-y-auto overflow-x-hidden"
                                      style={{ height: "auto", maxHeight: "200px" }}
                                    >
                                      {/* ==============================subhead data================================ */}
            
                                      <div className="row fs-12px text-black-60 p-1 mt-1">
                                        <div
                                          className="col text-start px-0"
                                          style={{ width: "20%" }}
                                        >
                                          vendor
                                        </div>
                                        <div
                                          className="col text-start px-0 d-flex justify-content-between align-items-center"
                                          style={{ width: "20%" }}
                                        >
                                          Invoice No/Date
                                          <span>
                                            <i className="icon-info cursor-pointer pe-2"></i>
                                          </span>
                                        </div>
                                        <div
                                          className="col text-start px-0 d-flex justify-content-between align-items-center"
                                          style={{ width: "20%" }}
                                        >
                                          Sanction Order/Date
                                          <span>
                                            <i className="icon-info cursor-pointer pe-2"></i>
                                          </span>
                                        </div>
                                        <div
                                          className="col text-start px-0"
                                          style={{ width: "20%" }}
                                        >
                                          Sanction Amount
                                        </div>
                                        <div
                                          className="col text-start px-0"
                                          style={{ width: "20%" }}
                                        >
                                          Action
                                        </div>
                                      </div>
                                      {invoices.length == 0 ? (
                                        <div>No Records fount</div>
                                      ) : (
                                        invoices?.map((val, index) => (
                                          <div
                                            className="row fs-14px p-1 fw-500 overflow-hidden" key={index}
                                            style={{
                                              height: "35px",
                                            }}
                                          >
                                            <div
                                              className="row fs-14px p-1 fw-500"
                                              style={{
                                                backgroundColor:
                                                  index % 2 === 0 ? "#f8f8f8" : "white",
                                              }}
                                            >
                                              <div
                                                className="col d-flex align-items-center"
                                                style={{ widows: "20%" }}
                                              >
                                                <span>
                                                  {addElipsis(val?.company_name, 12)}
                                                </span>
                                              </div>
            
                                              <div className="col" style={{ width: "20%" }}>
                                                {addElipsis(
                                                  val?.invoice_no +
                                                    " | " +
                                                    val?.invoice_date,
                                                  18
                                                )}
                                              </div>
                                              <div className="col" style={{ width: "20%" }}>
                                                {val?.sanction_order_value} |{" "}
                                                {val?.sanction_order_date}
                                              </div>
                                              <div
                                                className="col text-success-100"
                                                style={{ width: "20%" }}
                                              >
                                                {formatNumber(
                                                  val?.sanction_amount / dividerNumber,
                                                  "indian"
                                                )}
                                              </div>
                                              <div
                                                className="col d-flex gap-2"
                                                style={{ width: "20%" }}
                                              >
                                                <button
                                                  className={`${
                                                    val?.approval_status == 0
                                                      ? val?.l3_approval_status == 2
                                                        ? "-"
                                                        : "bg-warning-20"
                                                      : val?.approval_status == 1
                                                      ? "bg-success-20"
                                                      : "bg-danger-20 "
                                                  }   d-flex align-items-center gap-2 border-0`}
                                                  style={{
                                                    padding: "2px 8px",
                                                    borderRadius: "4px",
                                                  }}
                                                >
                                                  L2
                                                  {val?.approval_status == 0 ? (
                                                    val?.l3_approval_status == 2 ? (
                                                      "-"
                                                    ) : (
                                                      <i className="icon-warning_amber text-warning-100"></i>
                                                    )
                                                  ) : val?.approval_status == 1 ? (
                                                    <i className="icon-verified text-success-100"></i>
                                                  ) : (
                                                    <i className="icon-close_circle_stroke text-danger-100"></i>
                                                  )}
                                                </button>
                                                <button
                                                  className={`${
                                                    val?.l3_approval_status == 0
                                                      ? val?.approval_status == 2
                                                        ? "-"
                                                        : "bg-warning-20"
                                                      : val?.l3_approval_status == 1
                                                      ? "bg-success-20"
                                                      : "bg-danger-20 "
                                                  }   d-flex align-items-center gap-2 border-0`}
                                                  style={{
                                                    padding: "2px 8px",
                                                    borderRadius: "4px",
                                                  }}
                                                >
                                                  L3
                                                  {val?.l3_approval_status == 0 ? (
                                                    val?.approval_status == 2 ? (
                                                      "-"
                                                    ) : (
                                                      <i className="icon-warning_amber text-warning-100"></i>
                                                    )
                                                  ) : val?.l3_approval_status == 1 ? (
                                                    <i className="icon-verified text-success-100"></i>
                                                  ) : (
                                                    <i className="icon-close_circle_stroke text-danger-100"></i>
                                                  )}
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        ))
                                      )}
                                    </div>
                                  </Accordion.Body>
                                </Accordion.Item>
                              </Accordion>
                              {/* ==============================pending for payment============== */}
                              <Accordion style={{ border: "80" }}>
                                <Accordion.Item
                                  eventKey="80"
                                  style={{ borderRadius: "0", border: "0" }}
                                >
                                  <Accordion.Header
                                    onClick={() => toggleAccordion("80")}
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      position: "relative",
                                      borderRadius: "0",
                                    }}
                                  >
                                    <div className="w-100 d-flex justify-content-between">
                                      <span>Pending for Payment</span>
                                      <span
                                        className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                        style={{ height: "13.33px", width: "13.33px" }}
                                      >
                                        {activeKeys.includes("80") ? "-" : "+"}
                                      </span>
                                    </div>
                                  </Accordion.Header>
            
                                  <Accordion.Body>
                                    <div
                                      className="ps-3 overflow-y-auto overflow-x-hidden"
                                      style={{ height: "auto", maxHeight: "200px" }}
                                    >
                                      {/* ==============================subhead data================================ */}
                                      {vendorPaymentData.length != 0 && (
                                        <div className="row fs-12px text-black-60 p-1 mt-1">
                                          <div
                                            className="col text-start px-0"
                                            style={{ width: "20%" }}
                                          >
                                            vendor
                                          </div>
                                          <div
                                            className="col text-start px-0 d-flex justify-content-between align-items-center"
                                            style={{ width: "20%" }}
                                          >
                                            Invoice No/Date
                                            <span>
                                              <i className="icon-info cursor-pointer pe-2"></i>
                                            </span>
                                          </div>
                                          <div
                                            className="col text-start px-0 d-flex justify-content-between align-items-center"
                                            style={{ width: "20%" }}
                                          >
                                            Sanction Order/Date
                                            <span>
                                              <i className="icon-info cursor-pointer pe-2"></i>
                                            </span>
                                          </div>
                                          <div
                                            className="col text-start px-0"
                                            style={{ width: "20%" }}
                                          >
                                            Payment Amount
                                          </div>
                                          <div
                                            className="col text-start px-0"
                                            style={{ width: "20%" }}
                                          >
                                            Action
                                          </div>
                                        </div>
                                      )}
            
                                      {vendorPaymentData.length == 0 ? (
                                        <div>No Records Found</div>
                                      ) : (
                                        vendorPaymentData?.map((val, index) => (
                                          <div
                                            className="row fs-14px p-1 fw-500 overflow-hidden" key={index}
                                            style={{
                                              height: subheadAccording
                                                ? "35px"
                                                : "fit-content",
                                            }}
                                          >
                                            <div
                                              className="row fs-14px p-1 fw-500"
                                              style={{
                                                backgroundColor:
                                                  index % 2 === 0 ? "#f8f8f8" : "white",
                                              }}
                                            >
                                              <div
                                                className="col d-flex align-items-center"
                                                style={{ widows: "20%" }}
                                              >
                                                <span>
                                                  {addElipsis(val?.company_name, 12)}
                                                </span>
                                              </div>
            
                                              <div className="col" style={{ width: "20%" }}>
                                                {addElipsis(
                                                  val?.invoice_no +
                                                    " | " +
                                                    val?.invoice_date,
                                                  18
                                                )}
                                              </div>
                                              <div className="col" style={{ width: "20%" }}>
                                                {val?.sanction_order_value} |{" "}
                                                {val?.sanction_order_date}
                                              </div>
                                              <div
                                                className="col text-success-100"
                                                style={{ width: "20%" }}
                                              >
                                                {formatNumber(
                                                  val?.payable_amount / dividerNumber,
                                                  "indian"
                                                )}
                                              </div>
                                              <div
                                                className="col d-flex gap-2"
                                                style={{ width: "20%" }}
                                              >
                                                <button
                                                  className={`${
                                                    val?.payment_status == 0
                                                      ? val?.l3_payment_status == 2
                                                        ? "-"
                                                        : "bg-warning-20"
                                                      : val?.payment_status == 1
                                                      ? "bg-success-20"
                                                      : "bg-danger-20 "
                                                  }   d-flex align-items-center gap-2 border-0`}
                                                  style={{
                                                    padding: "2px 8px",
                                                    borderRadius: "4px",
                                                  }}
                                                >
                                                  L2
                                                  {val?.payment_status == 0 ? (
                                                    val?.l3_payment_status == 2 ? (
                                                      "-"
                                                    ) : (
                                                      <i className="icon-warning_amber text-warning-100"></i>
                                                    )
                                                  ) : val?.payment_status == 1 ? (
                                                    <i className="icon-verified text-success-100"></i>
                                                  ) : (
                                                    <i className="icon-close_circle_stroke text-danger-100"></i>
                                                  )}
                                                </button>
                                                <button
                                                  className={`${
                                                    val?.l3_payment_status == 0
                                                      ? val?.payment_status == 2
                                                        ? "-"
                                                        : "bg-warning-20"
                                                      : val?.l3_payment_status == 1
                                                      ? "bg-success-20"
                                                      : "bg-danger-20 "
                                                  }   d-flex align-items-center gap-2 border-0`}
                                                  style={{
                                                    padding: "2px 8px",
                                                    borderRadius: "4px",
                                                  }}
                                                >
                                                  L3
                                                  {val?.l3_payment_status == 0 ? (
                                                    val?.payment_status == 2 ? (
                                                      "-"
                                                    ) : (
                                                      <i className="icon-warning_amber text-warning-100"></i>
                                                    )
                                                  ) : val?.payment_status == 1 ? (
                                                    <i className="icon-verified text-success-100"></i>
                                                  ) : (
                                                    <i className="icon-close_circle_stroke text-danger-100"></i>
                                                  )}
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        ))
                                      )}
                                    </div>
                                  </Accordion.Body>
                                </Accordion.Item>
                              </Accordion>
                            </div>
                          </div>
            
                          {/* ===========================DBT/nach card=========================== */}
            
                          <div
                            className="bg-white border-Prime-100"
                            style={{ borderRadius: "8px" }}
                            // key={val?.id}
                          >
                            <div
                              className="bg-prime-20 d-flex justify-content-between align-items-center p-2 transition overflow-hidden"
                              style={{ borderRadius: "8px 8px 0 0" }}
                            >
                              {/* ======================card header================== */}
                              <span
                                className="fs-14px white-space-nowrap overflow-x-hidden"
                                style={{ width: "95%", fontStyle: "italic" }}
                              >
                                {/* =======================card header====================== */}
                                <span
                                  className="fs-14px white-space-nowrap overflow-x-hidden "
                                  style={{ width: "95%", fontStyle: "italic" }}
                                >
                                  <span className="fw-500 text-secondary-100">
                                    DBT/NACH
                                  </span>
                                </span>
                              </span>
            
                              <span>
                                <i className="icon-remove_red_eye cursor-pointer"></i>
                              </span>
                            </div>
            
                            {/* ================== card body ========================= */}
            
                            <div className="row py-2 px-3">
                              <div className="row">
                                <div className="col-4 d-flex flex-column">
                                  <span className="text-black-60 fs-12px">Approval</span>
                                  <span className="fw-500 fs-14px">
                                    {totalSanctionAmountDbt == 0
                                      ? "-"
                                      : formatNumber(
                                          totalSanctionAmountDbt / dividerNumber,
                                          "indian"
                                        )}
                                  </span>
                                </div>
                                <div className="col-4 d-flex flex-column">
                                  <span className="text-black-60 fs-12px d-flex justify-content-between align-items-center">
                                    Payment
                                    <span>
                                      <i className="icon-info cursor-pointer"></i>
                                    </span>
                                  </span>
                                  <span className="fw-500 fs-14px">
                                  {totalSanctionPaymentAmountDbt == 0
                                      ? "-"
                                      : formatNumber(
                                        totalSanctionPaymentAmountDbt / dividerNumber,
                                          "indian"
                                        )}
                                    </span>
                                </div>
                                <div className="col-4 d-flex flex-column bg-success-20 py-2">
                                  <span className="text-black-60 fs-12px d-flex justify-content-between align-items-center">
                                    Total
                                    <span>
                                      <i className="icon-info cursor-pointer"></i>
                                    </span>
                                  </span>
                                  <span className="fw-500 fs-14px">
                                  {totalSanctionAmountDbt + totalSanctionPaymentAmountDbt ==
                                    0
                                      ? "-"
                                      : formatNumber(
                                          (totalSanctionAmountDbt +
                                            totalSanctionPaymentAmountDbt) /
                                            dividerNumber,
                                          "indian"
                                        )}
                                  </span>
                                </div>
                              </div>
                            </div>
            
                            <div className="d-flex">
                              <div className="ps-3 py-2 d-flex gap-8px invoice-hover">
                                <span
                                  className="d-flex align-items-center border rounded-2 gap-8px"
                                  style={{ padding: "2px 8px" }}
                                >
                                  DBT/Nach for Approval - {dbtData.length}
                                  <i
                                    className="icon-open_in_new cursor-pointer"
                                    onClick={() =>
                                      navigate("beneficiary-reimbursement/approval")
                                    }
                                  ></i>
                                </span>
                              </div>
                              <div className="px-3 py-2 d-flex gap-8px invoice-hover">
                                <span
                                  className="d-flex align-items-center border rounded-2 gap-8px"
                                  style={{ padding: "2px 8px" }}
                                >
                                  DBT/Nach for Payment - {dbtPaymentData.length}
                                  <i
                                    className="icon-open_in_new cursor-pointer"
                                    onClick={() =>
                                      navigate("beneficiary-reimbursement/payment")
                                    }
                                  ></i>
                                </span>
                              </div>
                            </div>
            
                            <div className="px-3 pb-2 d-flex flex-column gap-1">
                              <Accordion activeKey={activeKeys} style={{ border: "0" }}>
                                <Accordion.Item
                                  eventKey="9"
                                  style={{ borderRadius: "0", border: "0" }}
                                >
                                  <Accordion.Header
                                    onClick={() => toggleAccordion("9")}
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      position: "relative",
                                      borderRadius: "0",
                                    }}
                                  >
                                    <div className="w-100 d-flex justify-content-between">
                                      <span>Pending for Approval</span>
                                      <span
                                        className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                        style={{ height: "13.33px", width: "13.33px" }}
                                      >
                                        {activeKeys.includes("9") ? "-" : "+"}
                                      </span>
                                    </div>
                                  </Accordion.Header>
            
                                  <Accordion.Body>
                                    <div>
                                      {/* ==============================subhead data================================ */}
                                      {dbtData.length == 0 ? null : (
                                        <div className="row fs-12px text-black-60 p-1 mt-1">
                                          <div
                                            className="col text-start px-0"
                                            style={{ width: "20%" }}
                                          >
                                            Department Level/Name
                                          </div>
                                          <div
                                            className="col text-start px-0 d-flex justify-content-between align-items-center"
                                            style={{ width: "20%" }}
                                          >
                                            Scheme/Subhead Code
                                            <span>
                                              <i className="icon-info cursor-pointer pe-2"></i>
                                            </span>
                                          </div>
                                          <div
                                            className="col text-start px-0 d-flex justify-content-between align-items-center"
                                            style={{ width: "20%" }}
                                          >
                                            Order No./Date
                                            <span>
                                              <i className="icon-info cursor-pointer pe-2"></i>
                                            </span>
                                          </div>
                                          <div
                                            className="col text-start px-0"
                                            style={{ width: "20%" }}
                                          >
                                            Sanction Amount
                                          </div>
                                          <div
                                            className="col text-start px-0"
                                            style={{ width: "20%" }}
                                          >
                                            Action
                                          </div>
                                        </div>
                                      )}
            
                                      {dbtData.length == 0 ? (
                                        <div>No Record's Found</div>
                                      ) : (
                                        dbtData?.map((val, ind) => (
                                          <div
                                            className="row fs-14px p-1 fw-500 overflow-hidden" key={ind}
                                            style={{
                                              height: subheadAccordingdbt[ind]
                                                ? "35px"
                                                : "fit-content",
                                            }}
                                          >
                                            <div
                                              className="row fs-14px p-1 fw-500"
                                              style={{
                                                background:
                                                  ind % 2 === 0 ? "#F8F8F8" : "transparent",
                                              }}
                                              onClick={() =>
                                                getSingleBeneficiaryReimbursements(val?.id)
                                              }
                                            >
                                              <div
                                                className="col d-flex align-items-center"
                                                style={{ width: "20%" }}
                                              >
                                                {subheadAccordingdbt[ind] ? (
                                                  <i
                                                    className="icon-keyboard_arrow_right cursor-pointer"
                                                    onClick={() =>
                                                      toggleSubheadAccording(ind)
                                                    }
                                                  ></i>
                                                ) : (
                                                  <i
                                                    className="icon-keyboard_arrow_down cursor-pointer"
                                                    onClick={() =>
                                                      toggleSubheadAccording(ind)
                                                    }
                                                  ></i>
                                                )}
                                                <span>
                                                  {" "}
                                                  {addElipsis(
                                                    val?.department_level +
                                                      " | " +
                                                      val?.department_name,
                                                    13
                                                  )}
                                                </span>
                                              </div>
            
                                              <div className="col" style={{ width: "20%" }}>
                                                {val?.code} | {val?.subhead_code}
                                              </div>
                                              <div className="col" style={{ width: "20%" }}>
                                                {addElipsis(
                                                  val?.reimbursement_order_no +
                                                    " | " +
                                                    val?.reimbursement_order_date,
                                                  13
                                                )}
                                              </div>
                                              <div className="col" style={{ width: "20%" }}>
                                                {val?.reimbursement_order_value == 0
                                                  ? "-"
                                                  : formatNumber(
                                                      val?.reimbursement_order_value /
                                                        dividerNumber,
                                                      "indian"
                                                    )}
                                              </div>
                                              <div
                                                className="col d-flex gap-2"
                                                style={{ width: "20%" }}
                                              >
                                                {val?.l2_approval == null ? (
                                                  <button
                                                    className="border-0 bg-warning-20 d-flex align-items-center gap-2"
                                                    style={{
                                                      padding: "2px 8px",
                                                      borderRadius: "4px",
                                                    }}
                                                  >
                                                    L2
                                                    <i className="icon-warning_amber text-warning-100"></i>
                                                  </button>
                                                ) : val?.l2_approval == 1 ? (
                                                  <button
                                                    className="border-0 bg-success-20 d-flex align-items-center gap-2"
                                                    style={{
                                                      padding: "2px 8px",
                                                      borderRadius: "4px",
                                                    }}
                                                  >
                                                    L2
                                                    <i className="icon-verified text-success-100"></i>
                                                  </button>
                                                ) : (
                                                  <button
                                                    className="border-0 bg-danger-20 d-flex align-items-center gap-2"
                                                    style={{
                                                      padding: "2px 8px",
                                                      borderRadius: "4px",
                                                    }}
                                                  >
                                                    L2
                                                    <i className="icon-close_circle_stroke  text-danger-100"></i>
                                                  </button>
                                                )}
                                                {val?.l3_approval == null ? (
                                                  <button
                                                    className="border-0 bg-warning-20 d-flex align-items-center gap-2"
                                                    style={{
                                                      padding: "2px 8px",
                                                      borderRadius: "4px",
                                                    }}
                                                  >
                                                    L3
                                                    <i className="icon-warning_amber text-warning-100"></i>
                                                  </button>
                                                ) : val?.l3_approval == 1 ? (
                                                  <button
                                                    className="border-0 bg-success-20 d-flex align-items-center gap-2"
                                                    style={{
                                                      padding: "2px 8px",
                                                      borderRadius: "4px",
                                                    }}
                                                  >
                                                    L3
                                                    <i className="icon-verified text-success-100"></i>
                                                  </button>
                                                ) : (
                                                  <button
                                                    className="border-0 bg-danger-20 d-flex align-items-center gap-2"
                                                    style={{
                                                      padding: "2px 8px",
                                                      borderRadius: "4px",
                                                    }}
                                                  >
                                                    L3
                                                    <i className="icon-close_circle_stroke  text-danger-100"></i>
                                                  </button>
                                                )}
                                              </div>
                                            </div>
            
                                            <div className="mt-1 p-0 pe-3">
                                              <table className="border-0">
                                                <tr className="bg-prime-20 border-0">
                                                  <th className="p-1 border-0 text-start fs-12px text-black-60">
                                                    Name
                                                  </th>
                                                  <th className="p-1 border-0 text-start fs-12px text-black-60">
                                                    Mobile/Email
                                                  </th>
                                                  <th className="p-1 border-0 text-start fs-12px text-black-60">
                                                    IFSC
                                                  </th>
                                                  <th className="p-1 border-0 text-start fs-12px text-black-60">
                                                    Gross Amount
                                                  </th>
                                                  <th className="p-1 border-0 text-start fs-12px text-black-60">
                                                    Deduction
                                                  </th>
                                                  <th className="p-1 border-0 text-start fs-12px text-black-60">
                                                    Net Amount
                                                  </th>
                                                </tr>
                                                {singleBeneficiarys?.map((val, ind) => (
                                                  <tr key={ind}>
                                                    <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                      {val?.name}
                                                    </td>
                                                    <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                      {val?.mobile} | {val?.email}
                                                    </td>
                                                    <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                      {val?.ifsc}
                                                    </td>
                                                    <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                      {val?.gross_amount == 0
                                                        ? "-"
                                                        : formatNumber(
                                                            val?.gross_amount /
                                                              dividerNumber,
                                                            "indian"
                                                          )}
                                                    </td>
                                                    <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                      {val?.deduction_amount == 0
                                                        ? "-"
                                                        : formatNumber(
                                                            val?.deduction_amount /
                                                              dividerNumber,
                                                            "indian"
                                                          )}
                                                    </td>
                                                    <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                      {Number(val?.gross_amount) -
                                                        Number(val?.deduction_amount) ==
                                                      0
                                                        ? "-"
                                                        : formatNumber(
                                                            (Number(val?.gross_amount) -
                                                              Number(
                                                                val?.deduction_amount
                                                              )) /
                                                              dividerNumber,
                                                            "indian"
                                                          )}
                                                    </td>
                                                  </tr>
                                                ))}
                                              </table>
                                            </div>
                                          </div>
                                        ))
                                      )}
                                    </div>
                                  </Accordion.Body>
                                </Accordion.Item>
                              </Accordion>
            
                              <Accordion style={{ border: "0" }}>
                                <Accordion.Item
                                  eventKey="82"
                                  style={{ borderRadius: "0", border: "0" }}
                                >
                                  <Accordion.Header
                                    onClick={() => toggleAccordion("82")}
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      position: "relative",
                                      borderRadius: "0",
                                    }}
                                  >
                                    <div className="w-100 d-flex justify-content-between">
                                      <span>Pending for payment</span>
                                      <span
                                        className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                        style={{ height: "13.33px", width: "13.33px" }}
                                      >
                                        {activeKeys.includes("82") ? "-" : "+"}
                                      </span>
                                    </div>
                                  </Accordion.Header>
            
                                  <Accordion.Body>
                                    <div>
                                      {/* ==============================subhead data================================ */}
            
                                      <div className="row fs-12px text-black-60 p-1 mt-1">
                                        <div
                                          className="col text-start px-0"
                                          style={{ width: "20%" }}
                                        >
                                          Department Level/Name
                                        </div>
                                        <div
                                          className="col text-start px-0 d-flex justify-content-between align-items-center "
                                          style={{ width: "20%" }}
                                        >
                                          Scheme/Subhead Code
                                          <span>
                                            <i className="icon-info cursor-pointer pe-2"></i>
                                          </span>
                                        </div>
                                        <div
                                          className="col text-start px-0 d-flex justify-content-between align-items-center "
                                          style={{ width: "20%" }}
                                        >
                                          Order No./Date
                                          <span>
                                            <i className="icon-info cursor-pointer pe-2"></i>
                                          </span>
                                        </div>
                                        <div
                                          className="col text-start px-0"
                                          style={{ width: "20%" }}
                                        >
                                          Sanction Amount
                                        </div>
                                        <div
                                          className="col text-start px-0"
                                          style={{ width: "20%" }}
                                        >
                                          Action
                                        </div>
                                      </div>
            
                                      {dbtPaymentData.length == 0 ? (
                                        <div>No Record's Found</div>
                                      ) : (
                                        dbtPaymentData?.map((val, ind) => (
                                          <div
                                            className="row fs-14px p-1 fw-500 overflow-hidden" key={ind}
                                            style={{
                                              height: subheadAccordingdbt[ind]
                                                ? "35px"
                                                : "fit-content",
                                            }}
                                          >
                                            <div
                                              className="row fs-14px p-1 fw-500"
                                              style={{
                                                background:
                                                  ind % 2 === 0 ? "#F8F8F8" : "transparent",
                                              }}
                                              onClick={() =>
                                                getSingleBeneficiaryReimbursements(val?.id)
                                              }
                                            >
                                              <div
                                                className="col d-flex align-items-center"
                                                style={{ width: "20%" }}
                                              >
                                                {subheadAccordingdbt[ind] ? (
                                                  <i
                                                    className="icon-keyboard_arrow_right cursor-pointer"
                                                    onClick={() =>
                                                      toggleSubheadAccording(ind)
                                                    }
                                                  ></i>
                                                ) : (
                                                  <i
                                                    className="icon-keyboard_arrow_down cursor-pointer"
                                                    onClick={() =>
                                                      toggleSubheadAccording(ind)
                                                    }
                                                  ></i>
                                                )}
                                                <span>
                                                  {" "}
                                                  {addElipsis(
                                                    val?.department_level +
                                                      " | " +
                                                      val?.department_name,
                                                    13
                                                  )}
                                                </span>
                                              </div>
            
                                              <div className="col" style={{ width: "20%" }}>
                                                {val?.code} | {val?.subhead_code}
                                              </div>
                                              <div className="col" style={{ width: "20%" }}>
                                                {addElipsis(
                                                  val?.reimbursement_order_no +
                                                    " | " +
                                                    val?.reimbursement_order_date,
                                                  13
                                                )}
                                              </div>
                                              <div className="col" style={{ width: "20%" }}>
                                                {val?.reimbursement_order_value == 0
                                                  ? "-"
                                                  : formatNumber(
                                                      val?.reimbursement_order_value /
                                                        dividerNumber,
                                                      "indian"
                                                    )}
                                              </div>
                                              <div
                                                className="col d-flex gap-2"
                                                style={{ width: "20%" }}
                                              >
                                                {val?.l2_payment_approval == null ? (
                                                  <button
                                                    className="border-0 bg-warning-20 d-flex align-items-center gap-2"
                                                    style={{
                                                      padding: "2px 8px",
                                                      borderRadius: "4px",
                                                    }}
                                                  >
                                                    L2
                                                    <i className="icon-warning_amber text-warning-100"></i>
                                                  </button>
                                                ) : val?.l2_payment_approval == 1 ? (
                                                  <button
                                                    className="border-0 bg-success-20 d-flex align-items-center gap-2"
                                                    style={{
                                                      padding: "2px 8px",
                                                      borderRadius: "4px",
                                                    }}
                                                  >
                                                    L2
                                                    <i className="icon-verified text-success-100"></i>
                                                  </button>
                                                ) : (
                                                  <button
                                                    className="border-0 bg-danger-20 d-flex align-items-center gap-2"
                                                    style={{
                                                      padding: "2px 8px",
                                                      borderRadius: "4px",
                                                    }}
                                                  >
                                                    L2
                                                    <i className="icon-close_circle_stroke  text-danger-100"></i>
                                                  </button>
                                                )}
                                                {val?.l3_payment_approval == null ? (
                                                  <button
                                                    className="border-0 bg-warning-20 d-flex align-items-center gap-2"
                                                    style={{
                                                      padding: "2px 8px",
                                                      borderRadius: "4px",
                                                    }}
                                                  >
                                                    L3
                                                    <i className="icon-warning_amber text-warning-100"></i>
                                                  </button>
                                                ) : val?.l3_payment_approval == 1 ? (
                                                  <button
                                                    className="border-0 bg-success-20 d-flex align-items-center gap-2"
                                                    style={{
                                                      padding: "2px 8px",
                                                      borderRadius: "4px",
                                                    }}
                                                  >
                                                    L3
                                                    <i className="icon-verified text-success-100"></i>
                                                  </button>
                                                ) : (
                                                  <button
                                                    className="border-0 bg-danger-20 d-flex align-items-center gap-2"
                                                    style={{
                                                      padding: "2px 8px",
                                                      borderRadius: "4px",
                                                    }}
                                                  >
                                                    L3
                                                    <i className="icon-close_circle_stroke  text-danger-100"></i>
                                                  </button>
                                                )}
                                              </div>
                                            </div>
            
                                            <div className="mt-1 p-0 pe-3">
                                              <table className="border-0">
                                                <tr className="bg-prime-20 border-0">
                                                  <th className="p-1 border-0 text-start fs-12px text-black-60">
                                                    Name
                                                  </th>
                                                  <th className="p-1 border-0 text-start fs-12px text-black-60">
                                                    Mobile/Email
                                                  </th>
                                                  <th className="p-1 border-0 text-start fs-12px text-black-60">
                                                    IFSC
                                                  </th>
                                                  <th className="p-1 border-0 text-start fs-12px text-black-60">
                                                    Gross Amount
                                                  </th>
                                                  <th className="p-1 border-0 text-start fs-12px text-black-60">
                                                    Deduction
                                                  </th>
                                                  <th className="p-1 border-0 text-start fs-12px text-black-60">
                                                    Net Amount
                                                  </th>
                                                </tr>
                                                {singleBeneficiarys?.map((val, ind) => (
                                                  <tr key={ind}>
                                                    <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                      {val?.name}
                                                    </td>
                                                    <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                      {val?.mobile} | {val?.email}
                                                    </td>
                                                    <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                      {val?.ifsc}
                                                    </td>
                                                    <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                      {val?.gross_amount == 0
                                                        ? "-"
                                                        : formatNumber(
                                                            val?.gross_amount /
                                                              dividerNumber,
                                                            "indian"
                                                          )}
                                                    </td>
                                                    <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                      {val?.deduction_amount == 0
                                                        ? "-"
                                                        : formatNumber(
                                                            val?.deduction_amount /
                                                              dividerNumber,
                                                            "indian"
                                                          )}
                                                    </td>
                                                    <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                      {Number(val?.gross_amount) -
                                                        Number(val?.deduction_amount) ==
                                                      0
                                                        ? "-"
                                                        : formatNumber(
                                                            (Number(val?.gross_amount) -
                                                              Number(
                                                                val?.deduction_amount
                                                              )) /
                                                              dividerNumber,
                                                            "indian"
                                                          )}
                                                    </td>
                                                  </tr>
                                                ))}
                                              </table>
                                            </div>
                                          </div>
                                        ))
                                      )}
                                    </div>
                                  </Accordion.Body>
                                </Accordion.Item>
                              </Accordion>
                            </div>
                          </div>
            
                          {/* =================salary card========================= */}
            

                          <div
                            className="bg-white border-Prime-100"
                            style={{ borderRadius: "8px" }}
                            // key={val?.id}
                          >
                            <div
                              className="bg-prime-20 d-flex justify-content-between align-items-center p-2 transition overflow-hidden "
                              style={{ borderRadius: "8px 8px 0 0" }}
                            >
                              {/* ======================card header================== */}
                              <span
                                className="fs-14px white-space-nowrap overflow-x-hidden"
                                style={{ width: "95%", fontStyle: "italic" }}
                              >
                                {/* =======================card header====================== */}
                                <span
                                  className="fs-14px white-space-nowrap overflow-x-hidden "
                                  style={{ width: "95%", fontStyle: "italic" }}
                                >
                                  <span className="fw-500 text-secondary-100">Salary</span>
                                </span>
                              </span>
            
                              <span>
                                <i className="icon-remove_red_eye cursor-pointer"></i>
                              </span>
                            </div>
            
                            {/* ================== card body ========================= */}
            
                            <div className="row py-2 px-3">
                              <div className="row">
                                <div className="col-4 d-flex flex-column">
                                  <span className="text-black-60 fs-12px">Approval</span>
                                  <span className="fw-500 fs-14px">2,000,000,000.00</span>
                                </div>
                                <div className="col-4 d-flex flex-column">
                                  <span className="text-black-60 fs-12px">Payment</span>
                                  <span className="fw-500 fs-14px">2,000,000,000.00</span>
                                </div>
                                <div className="col-4 d-flex flex-column bg-success-20 py-2">
                                  <span className="text-black-60 fs-12px">Total</span>
                                  <span className="fw-500 fs-14px">2,000,000,000.00</span>
                                </div>
                              </div>
                            </div>
                            <div className="d-flex">
                              <div className="ps-3 py-2 d-flex gap-8px invoice-hover">
                                <span
                                  className="d-flex align-items-center border rounded-2 gap-8px"
                                  style={{ padding: "2px 8px" }}
                                >
                                  Invoice for Approval - 22{" "}
                                  <i
                                    className="icon-open_in_new cursor-pointer"
                                    onClick={() => navigate("/payroll-salary")}
                                  ></i>
                                </span>
                              </div>
                              <div className="ps-3 py-2 d-flex gap-8px invoice-hover">
                                <span
                                  className="d-flex align-items-center border rounded-2 gap-8px"
                                  style={{ padding: "2px 8px" }}
                                >
                                  Invoice for payment - 22{" "}
                                  <i
                                    className="icon-open_in_new cursor-pointer"
                                    onClick={() => navigate("/payroll-salary")}
                                  ></i>
                                </span>
                              </div>
                            </div>
                            <div className="px-3 pb-2 d-flex flex-column gap-1">
                              <Accordion activeKey={activeKeys} style={{ border: "0" }}>
                                <Accordion.Item
                                  eventKey="10"
                                  style={{ borderRadius: "0", border: "0" }}
                                >
                                  <Accordion.Header
                                    onClick={() => toggleAccordion("10")}
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      position: "relative",
                                      borderRadius: "0",
                                    }}
                                  >
                                    <div className="w-100 d-flex justify-content-between">
                                      <span>Pending for Approval</span>
                                      <span
                                        className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                        style={{ height: "13.33px", width: "13.33px" }}
                                      >
                                        {activeKeys.includes("10") ? "-" : "+"}
                                      </span>
                                    </div>
                                  </Accordion.Header>
            
                                  <Accordion.Body>
                                    <div>
                                      {/* ==============================subhead data================================ */}
            
                                      <div className="row fs-12px text-black-60 p-1 mt-1">
                                        <div
                                          className="col text-start px-0"
                                          style={{ width: "20%" }}
                                        >
                                          vendor
                                        </div>
                                        <div
                                          className="col text-start px-0"
                                          style={{ width: "20%" }}
                                        >
                                          Invoice No/Date
                                        </div>
                                        <div
                                          className="col text-start px-0"
                                          style={{ width: "20%" }}
                                        >
                                          Sanction Order/Date
                                        </div>
                                        <div
                                          className="col text-start px-0"
                                          style={{ width: "20%" }}
                                        >
                                          Sanction Amount
                                        </div>
                                        <div
                                          className="col text-start px-0"
                                          style={{ width: "20%" }}
                                        >
                                          Action
                                        </div>
                                      </div>
            
                                      <div
                                        className="row fs-14px p-1 fw-500 overflow-hidden"
                                        style={{
                                          height: subheadAccording ? "35px" : "fit-content",
                                        }}
                                      >
                                        <div
                                          className="row fs-14px p-1 fw-500"
                                          style={{ background: "#F8F8F8" }}
                                        >
                                          <div
                                            className="col d-flex align-items-center"
                                            style={{ widows: "20%" }}
                                          >
                                            {subheadAccording ? (
                                              <i
                                                className="icon-keyboard_arrow_right cursor-pointer"
                                                onClick={() =>
                                                  setSubheadAccording((prev) => !prev)
                                                }
                                              ></i>
                                            ) : (
                                              <i
                                                className="icon-keyboard_arrow_down cursor-pointer"
                                                onClick={() =>
                                                  setSubheadAccording((prev) => !prev)
                                                }
                                              ></i>
                                            )}
                                            <span>radhe krishna</span>
                                          </div>
            
                                          <div className="col" style={{ width: "20%" }}>
                                            25412 | 10/08/2025
                                          </div>
                                          <div className="col" style={{ width: "20%" }}>
                                            25412 | 10/08/2025
                                          </div>
                                          <div
                                            className="col text-success-100"
                                            style={{ width: "20%" }}
                                          >
                                            2,000,000,000.00
                                          </div>
                                          <div
                                            className="col d-flex gap-2"
                                            style={{ width: "20%" }}
                                          >
                                            <button
                                              className="border-0 bg-success-20 d-flex align-items-center gap-2"
                                              style={{
                                                padding: "2px 8px",
                                                borderRadius: "4px",
                                              }}
                                            >
                                              L2
                                              <i className="icon-verified text-success-100"></i>
                                            </button>
                                            <button
                                              className="border-0 bg-warning-20 d-flex align-items-center gap-2"
                                              style={{
                                                padding: "2px 8px",
                                                borderRadius: "4px",
                                              }}
                                            >
                                              L3
                                              <i className="icon-warning_amber text-warning-100"></i>
                                            </button>
                                          </div>
                                        </div>
            
                                        <div className="mt-1 p-0 pe-3">
                                          <table className="border-0">
                                            <tr className="bg-prime-20 border-0">
                                              <th className="p-1 border-0 text-start fs-12px text-black-60">
                                                Name
                                              </th>
                                              <th className="p-1 border-0 text-start fs-12px text-black-60">
                                                Mobile/Email
                                              </th>
                                              <th className="p-1 border-0 text-start fs-12px text-black-60">
                                                Action/IFSC
                                              </th>
                                              <th className="p-1 border-0 text-start fs-12px text-black-60">
                                                Gross Amount
                                              </th>
                                              <th className="p-1 border-0 text-start fs-12px text-black-60">
                                                Deduction
                                              </th>
                                              <th className="p-1 border-0 text-start fs-12px text-black-60">
                                                Net Amount
                                              </th>
                                            </tr>
                                            <tr>
                                              <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                radha krishna
                                              </td>
                                              <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                123456780
                                              </td>
                                              <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                123456780
                                              </td>
                                              <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                123456780
                                              </td>
                                              <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                123456780
                                              </td>
                                              <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                123456780
                                              </td>
                                            </tr>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </Accordion.Body>
                                </Accordion.Item>
                              </Accordion>
                              <Accordion style={{ border: "0" }}>
                                <Accordion.Item
                                  eventKey="10"
                                  style={{ borderRadius: "0", border: "0" }}
                                >
                                  <Accordion.Header
                                    onClick={() => toggleAccordion("83")}
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      position: "relative",
                                      borderRadius: "0",
                                    }}
                                  >
                                    <div className="w-100 d-flex justify-content-between">
                                      <span>Pending for payment</span>
                                      <span
                                        className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                        style={{ height: "13.33px", width: "13.33px" }}
                                      >
                                        {activeKeys.includes("10") ? "-" : "+"}
                                      </span>
                                    </div>
                                  </Accordion.Header>
            
                                  <Accordion.Body>
                                    <div>
                                      {/* ==============================subhead data================================ */}
            
                                      <div className="row fs-12px text-black-60 p-1 mt-1">
                                        <div
                                          className="col text-start px-0"
                                          style={{ width: "20%" }}
                                        >
                                          vendor
                                        </div>
                                        <div
                                          className="col text-start px-0"
                                          style={{ width: "20%" }}
                                        >
                                          Invoice No/Date
                                        </div>
                                        <div
                                          className="col text-start px-0"
                                          style={{ width: "20%" }}
                                        >
                                          Sanction Order/Date
                                        </div>
                                        <div
                                          className="col text-start px-0"
                                          style={{ width: "20%" }}
                                        >
                                          Amount
                                        </div>
                                        <div
                                          className="col text-start px-0"
                                          style={{ width: "20%" }}
                                        >
                                          Action
                                        </div>
                                      </div>
            
                                      <div
                                        className="row fs-14px p-1 fw-500 overflow-hidden"
                                        style={{
                                          height: subheadAccording ? "35px" : "fit-content",
                                        }}
                                      >
                                        <div
                                          className="row fs-14px p-1 fw-500"
                                          style={{ background: "#F8F8F8" }}
                                        >
                                          <div
                                            className="col d-flex align-items-center"
                                            style={{ widows: "20%" }}
                                          >
                                            {subheadAccording ? (
                                              <i
                                                className="icon-keyboard_arrow_right cursor-pointer"
                                                onClick={() =>
                                                  setSubheadAccording((prev) => !prev)
                                                }
                                              ></i>
                                            ) : (
                                              <i
                                                className="icon-keyboard_arrow_down cursor-pointer"
                                                onClick={() =>
                                                  setSubheadAccording((prev) => !prev)
                                                }
                                              ></i>
                                            )}
                                            <span>radhe krishna</span>
                                          </div>
            
                                          <div className="col" style={{ width: "20%" }}>
                                            25412 | 10/08/2025
                                          </div>
                                          <div className="col" style={{ width: "20%" }}>
                                            25412 | 10/08/2025
                                          </div>
                                          <div
                                            className="col text-success-100"
                                            style={{ width: "20%" }}
                                          >
                                            2,000,000,000.00
                                          </div>
                                          <div
                                            className="col d-flex gap-2"
                                            style={{ width: "20%" }}
                                          >
                                            <button
                                              className="border-0 bg-success-20 d-flex align-items-center gap-2"
                                              style={{
                                                padding: "2px 8px",
                                                borderRadius: "4px",
                                              }}
                                            >
                                              L2
                                              <i className="icon-verified text-success-100"></i>
                                            </button>
                                            <button
                                              className="border-0 bg-warning-20 d-flex align-items-center gap-2"
                                              style={{
                                                padding: "2px 8px",
                                                borderRadius: "4px",
                                              }}
                                            >
                                              L3
                                              <i className="icon-warning_amber text-warning-100"></i>
                                            </button>
                                          </div>
                                        </div>
            
                                        <div className="mt-1 p-0 pe-3">
                                          <table className="border-0">
                                            <tr className="bg-prime-20 border-0">
                                              <th className="p-1 border-0 text-start fs-12px text-black-60">
                                                Name
                                              </th>
                                              <th className="p-1 border-0 text-start fs-12px text-black-60">
                                                Mobile/Email
                                              </th>
                                              <th className="p-1 border-0 text-start fs-12px text-black-60">
                                                Action/IFSC
                                              </th>
                                              <th className="p-1 border-0 text-start fs-12px text-black-60">
                                                Gross Amount
                                              </th>
                                              <th className="p-1 border-0 text-start fs-12px text-black-60">
                                                Deduction
                                              </th>
                                              <th className="p-1 border-0 text-start fs-12px text-black-60">
                                                Net Amount
                                              </th>
                                            </tr>
                                            <tr>
                                              <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                radha krishna
                                              </td>
                                              <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                123456780
                                              </td>
                                              <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                123456780
                                              </td>
                                              <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                123456780
                                              </td>
                                              <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                123456780
                                              </td>
                                              <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                123456780
                                              </td>
                                            </tr>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </Accordion.Body>
                                </Accordion.Item>
                              </Accordion>
                            </div>
                          </div>
            
            
                          {/* ========================child allocatoin card======================================= */}
            
                          {date?.map((val, ind) => (
                            <div
                              className="bg-white border-Prime-100"
                              style={{ borderRadius: "8px" }}
                              key={val?.id}
                            >
                              <div
                                className="bg-prime-20 d-flex justify-content-between align-items-center p-2 transition overflow-hidden "
                                style={{ borderRadius: "8px 8px 0 0" }}
                              >
                                {/* ======================card header================== */}
                                <span
                                  className="fs-14px white-space-nowrap overflow-x-hidden"
                                  style={{ width: "95%", fontStyle: "italic" }}
                                >
                                  {/* =======================card header====================== */}
                                  <span
                                    className="fs-14px white-space-nowrap overflow-x-hidden "
                                    style={{ width: "95%", fontStyle: "italic" }}
                                  >
                                    <span className="fw-500 text-secondary-100">
                                      Budget Allocation
                                    </span>
                                  </span>
                                </span>
            
                                <span>
                                  <i className="icon-remove_red_eye cursor-pointer"></i>
                                </span>
                              </div>
            
                              {/* ================== Budget Allocation card body ========================= */}
            
                              <div className="row py-2 px-3">
                                <div className="row">
                                  <div className="col-6 d-flex flex-column">
                                    <span className="text-black-60 fs-12px">
                                      Total Provision{" "}
                                    </span>
                                    <span className="fw-500 fs-14px">
                                      {totalprovisonReduct == 0
                                        ? "-"
                                        : formatNumber(
                                            totalprovisonReduct / dividerNumber,
                                            "indian"
                                          )}
                                    </span>
                                  </div>
                                  <div className="col-6 d-flex flex-column">
                                    <span className="text-black-60 fs-12px">
                                      {" "}
                                      Total Released{" "}
                                    </span>
                                    <span className="fw-500 fs-14px">
                                      {totalprovisonReleased == 0
                                        ? "-"
                                        : formatNumber(
                                            totalprovisonReleased / dividerNumber,
                                            "indian"
                                          )}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="d-flex">
                                <div className="ps-3 py-2 d-flex gap-8px invoice-hover">
                                  <span
                                    className="d-flex align-items-center border rounded-2 gap-8px"
                                    style={{ padding: "2px 8px" }}
                                  >
                                    Budget Allocatoin for Approval -{" "}
                                    {lengthchildAllocationData}
                                    <i
                                      className="icon-open_in_new cursor-pointer"
                                      onClick={() => navigate("/allocate-budget-approval")}
                                    ></i>
                                  </span>
                                </div>
                              </div>
                              <div className="px-3 pb-2">
                                <Accordion activeKey={activeKeys} style={{ border: "0" }}>
                                  <Accordion.Item
                                    eventKey="11"
                                    style={{ borderRadius: "0", border: "0" }}
                                  >
                                    <Accordion.Header
                                      onClick={() => toggleAccordion("11")}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        position: "relative",
                                        borderRadius: "0",
                                      }}
                                    >
                                      <div className="w-100 d-flex justify-content-between">
                                        <span>Pending for Approval</span>
                                        <span
                                          className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                          style={{ height: "13.33px", width: "13.33px" }}
                                        >
                                          {activeKeys.includes("11") ? "-" : "+"}
                                        </span>
                                      </div>
                                    </Accordion.Header>
            
                                    <Accordion.Body>
                                      <div>
                                        {/* ==============================subhead data================================ */}
            
                                        <div className="row fs-12px text-black-60 p-1 mt-1">
                                          <div
                                            className="col text-start px-0"
                                            style={{ width: "20%" }}
                                          >
                                            Scheme Name
                                          </div>
                                          <div
                                            className="col text-start px-0 d-flex justify-content-between align-items-center"
                                            style={{ width: "30%" }}
                                          >
                                            Order No. | Date
                                            <span>
                                              <i className="icon-info cursor-pointer pe-2"></i>
                                            </span>
                                          </div>
                                          <div
                                            className="col text-start px-0 d-flex justify-content-between align-items-center"
                                            style={{ width: "10%" }}
                                          >
                                            Child Count
                                            <span>
                                              <i className="icon-info cursor-pointer pe-2"></i>
                                            </span>
                                          </div>
                                          <div
                                            className="col text-start px-0"
                                            style={{ width: "20%" }}
                                          >
                                            Provision Allocation
                                          </div>
                                          <div
                                            className="col text-start px-0"
                                            style={{ width: "20%" }}
                                          >
                                            Released Allocation
                                          </div>
                                          <div
                                            className="col text-start px-0"
                                            style={{ width: "20%" }}
                                          >
                                            Action
                                          </div>
                                        </div>
            
                                        {childAllocationData?.map((val, ind) => (
                                          <div
                                            className="row fs-14px p-1 fw-500 overflow-hidden"
                                            key={ind}
                                            style={{
                                              height:
                                                expandedIndex === ind
                                                  ? "fit-content"
                                                  : "35px",
                                            }}
                                          >
                                            <div
                                              className="row fs-14px p-1 fw-500"
                                              style={{
                                                background:
                                                  ind % 2 === 0 ? "#F8F8F8" : "transparent",
                                              }}
                                              onClick={() => fetchChildEyeData(val?.id)}
                                            >
                                              <div
                                                className="col d-flex align-items-center"
                                                style={{ widows: "20%" }}
                                              >
                                                {subheadAccording ? (
                                                  <i
                                                    className="icon-keyboard_arrow_right cursor-pointer"
                                                    onClick={() =>
                                                      setSubheadAccording((prev) => !prev)
                                                    }
                                                  ></i>
                                                ) : (
                                                  <i
                                                    className={`icon-${
                                                      expandedIndex === ind
                                                        ? "keyboard_arrow_down"
                                                        : "keyboard_arrow_right"
                                                    } cursor-pointer`}
                                                    onClick={() =>
                                                      setExpandedIndex(
                                                        expandedIndex === ind ? null : ind
                                                      )
                                                    }
                                                  ></i>
                                                )}
                                                <span>
                                                {addElipsis(val?.name, 13)}
                                                </span>
                                              </div>
            
                                              <div className="col" style={{ width: "30%" }}>
                                                {addElipsis(
                                                  val?.budget_order_no +
                                                    " " +
                                                    val?.budget_order_date,
                                                  13
                                                )}
                                              </div>
                                              <div className="col" style={{ width: "10%" }}>
                                                {val?.total_departments}
                                              </div>
                                              <div
                                                className="col text-success-100"
                                                style={{ width: "20%" }}
                                              >
                                                {val?.total_scheme_provisional_allocation ==
                                                0
                                                  ? "-"
                                                  : formatNumber(
                                                      val?.total_scheme_provisional_allocation /
                                                        dividerNumber,
                                                      "indian"
                                                    )}
                                              </div>
                                              <div
                                                className="col text-success-100"
                                                style={{ width: "20%" }}
                                              >
                                                {val?.total_scheme_released_allocation == 0
                                                  ? "-"
                                                  : formatNumber(
                                                      val?.total_scheme_released_allocation /
                                                        dividerNumber,
                                                      "indian"
                                                    )}
                                              </div>
                                              <div
                                                className="col d-flex gap-2"
                                                style={{ width: "20%" }}
                                              >
                                                {val?.l2_status == null ? (
                                                  <button
                                                    className="border-0 bg-warning-20 d-flex align-items-center gap-2"
                                                    style={{
                                                      padding: "2px 8px",
                                                      borderRadius: "4px",
                                                    }}
                                                  >
                                                    L2
                                                    <i className="icon-warning_amber text-warning-100"></i>
                                                  </button>
                                                ) : val?.l2_status == 1 ? (
                                                  <button
                                                    className="border-0 bg-success-20 d-flex align-items-center gap-2"
                                                    style={{
                                                      padding: "2px 8px",
                                                      borderRadius: "4px",
                                                    }}
                                                  >
                                                    L2
                                                    <i className="icon-verified text-success-100"></i>
                                                  </button>
                                                ) : (
                                                  <button
                                                    className="border-0 bg-danger-20 d-flex align-items-center gap-2"
                                                    style={{
                                                      padding: "2px 8px",
                                                      borderRadius: "4px",
                                                    }}
                                                  >
                                                    L2
                                                    <i className="icon-close_circle_stroke text-danger-100"></i>
                                                  </button>
                                                )}
                                                {val?.l3_status == null ? (
                                                  <button
                                                    className="border-0 bg-warning-20 d-flex align-items-center gap-2"
                                                    style={{
                                                      padding: "2px 8px",
                                                      borderRadius: "4px",
                                                    }}
                                                  >
                                                    L3
                                                    <i className="icon-warning_amber text-warning-100"></i>
                                                  </button>
                                                ) : val?.l3_status == 1 ? (
                                                  <button
                                                    className="border-0 bg-success-20 d-flex align-items-center gap-2"
                                                    style={{
                                                      padding: "2px 8px",
                                                      borderRadius: "4px",
                                                    }}
                                                  >
                                                    L2
                                                    <i className="icon-verified text-success-100"></i>
                                                  </button>
                                                ) : (
                                                  <button
                                                    className="border-0 bg-danger-20 d-flex align-items-center gap-2"
                                                    style={{
                                                      padding: "2px 8px",
                                                      borderRadius: "4px",
                                                    }}
                                                  >
                                                    L3
                                                    <i className="icon-close_circle_stroke text-danger-100"></i>
                                                  </button>
                                                )}
                                              </div>
                                            </div>
            
                                            <div className="mt-1 p-0 pe-3">
                                              <table className="border-0">
                                                <tr className="bg-prime-20 border-0">
                                                  <th className="p-1 border-0 text-start fs-12px text-black-60">
                                                    Department Level/Name
                                                  </th>
                                                  <th className="p-1 border-0 text-start fs-12px text-black-60">
                                                    Department Code
                                                  </th>
                                                  <th className="p-1 border-0 text-start fs-12px text-black-60">
                                                    Subhead Code
                                                  </th>
                                                  <th className="p-1 border-0 text-start fs-12px text-black-60">
                                                    Provisional Allocation
                                                  </th>
                                                  <th className="p-1 border-0 text-start fs-12px text-black-60">
                                                    Released Allocation
                                                  </th>
                                                </tr>
            
                                                {childAllocationEyeData?.map((val, ind) => (
                                                  <tr key={ind}>
                                                    <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                      {addElipsis(
                                                        val?.department_level +
                                                          " | " +
                                                          val?.name,
                                                        20
                                                      )}
                                                    </td>
                                                    <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                      {val?.department_code}
                                                    </td>
                                                    <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                      {val?.code}
                                                    </td>
                                                    <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                      {val?.provisional_budget == 0
                                                        ? "-"
                                                        : formatNumber(
                                                            val?.provisional_budget /
                                                              dividerNumber,
                                                            "indian"
                                                          )}
                                                    </td>
                                                    <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                      {val?.budget == 0
                                                        ? "-"
                                                        : formatNumber(
                                                            val?.budget / dividerNumber,
                                                            "indian"
                                                          )}
                                                    </td>
                                                  </tr>
                                                ))}
                                              </table>
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    </Accordion.Body>
                                  </Accordion.Item>
                                </Accordion>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
        </>
    )
}

export default ApprovalOverlay;